(() => {
  'use strict';
  if (window.NiralaProductBackInitialized) return;
  window.NiralaProductBackInitialized = true;

  // The normal link remains a working, locale-aware home fallback without JS.
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-product-back]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (!document.referrer || window.history.length < 2) return;
    try {
      const previous = new URL(document.referrer);
      const current = new URL(window.location.href);
      if (previous.origin !== current.origin || (previous.pathname === current.pathname && previous.search === current.search)) return;
      window.history.back();
      event.preventDefault();
    } catch (_) {
      // A denied History API call must leave the home link usable.
    }
  });
})();
